
#cta-root *,
.arsenal-cta-container * {
  box-sizing: border-box;
}

/* WordPress container isolation */
#cta-root,
.arsenal-cta-container {
  width: 100%;
  max-width: 1047.5px;
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
}

.arsenal-cta-wrapper {
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Stronger CSS isolation to prevent WordPress theme interference */
#cta-root .cta-section,
.arsenal-cta-container .cta-section {
  position: relative;
  width: 100%;
  max-width: 1047.5px;
  height: 440px;
  background-size: cover;
  background-position: center;
  border-radius: 20px;
  padding: 2.5rem 3.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0,0,0,0.15);
  margin: 0 auto;
  font-family: "Rajdhani", sans-serif;
}

.cta-section::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.2) 100%);
  z-index: 1;
}

.cta-content {
  flex: 1;
  max-width: 60%;
  z-index: 10;
  display: flex;
  flex-direction: column;
}

.cta-badge {
  align-self: flex-start;
  background: rgba(222, 52, 49, 0.15);
  color: #de3431;
  padding: 0.3rem 0.8rem;
  border-radius: 4px;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  font-size: 0.75rem;
  border: 1px solid rgba(222, 52, 49, 0.3);
}

.cta-title {
  font-size: 2.4rem;
  line-height: 1;
  margin: 0 0 0.5rem 0;
  text-transform: uppercase;
  color: #ffffff !important;
}

.highlight { color: #de3431; }

.cta-subtitle {
  font-size: 1.1rem;
  font-weight: 600;
  color: #ddd;
  margin-bottom: 0.4rem;
}

.cta-description {
  color: #bbb;
  line-height: 1.4;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
  max-width: 90%;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
}

.btn {
  padding: 0.7rem 1.6rem;
  text-decoration: none;
  font-weight: 700;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 0.9rem;
}

.btn-primary { 
  background: #de3431; 
  color: #fff;
  border: 2px solid #de3431;
}

.btn-primary:hover, .btn-primary:active {
  background: #000;
  color: #fff;
  border-color: #fff;
}

.btn-secondary { 
  border: 2px solid #de3431; 
  color: #de3431; 
  background: transparent;
}

.btn-secondary:hover, .btn-secondary:active {
  border-color: #fff;
  color: #fff;
}

.cta-image-wrapper {
  flex: 1;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
  overflow: visible;
}

/* Heading row wraps badge + title so mobile can put a small PC image next to them.
   display: contents makes the wrappers invisible in the box tree on desktop,
   so badge and title remain direct flex items of .cta-content exactly as before. */
.cta-heading-row,
.cta-heading-text {
  display: contents;
}

.cta-mobile-pc {
  display: none;
}

/* Stronger selectors for PC image to prevent WordPress theme interference */
#cta-root .pc-image,
.arsenal-cta-container .pc-image {
  width: 100% !important;
  max-width: 310px !important;
  height: auto !important;
  z-index: 10;
  filter: drop-shadow(0 0 30px rgba(222, 52, 49, 0.45));
  object-fit: contain !important;
}

.glow-effect {
  position: absolute;
  width: 320px;
  height: 320px;
  background: radial-gradient(circle, rgba(222, 52, 49, 0.75) 0%, rgba(222, 52, 49, 0.25) 45%, rgba(222, 52, 49, 0) 75%);
  filter: blur(50px);
  z-index: 1;
}

.particle-container {
  position: absolute;
  width: 150%;
  height: 150%;
  top: -25%;
  left: -25%;
  pointer-events: none;
  z-index: 2;
  overflow: visible;
}

.tech-particle {
  position: absolute;
  border-radius: 50%;
  background: rgba(222, 52, 49, 0.7);
  pointer-events: none;
  will-change: transform, opacity;
}

.particle-small {
  width: 6px;
  height: 6px;
  box-shadow: 0 0 8px rgba(222, 52, 49, 0.5), 0 0 15px rgba(222, 52, 49, 0.25);
}

.particle-medium {
  width: 8px;
  height: 8px;
  box-shadow: 0 0 12px rgba(222, 52, 49, 0.6), 0 0 20px rgba(222, 52, 49, 0.3);
}

.particle-large {
  width: 10px;
  height: 10px;
  box-shadow: 0 0 15px rgba(222, 52, 49, 0.7), 0 0 25px rgba(222, 52, 49, 0.35);
}

.circuit-line {
  position: absolute;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(222, 52, 49, 0.7), transparent);
  pointer-events: none;
  will-change: transform, opacity;
}

.circuit-dot {
  position: absolute;
  width: 4px;
  height: 4px;
  background: rgba(222, 52, 49, 0.8);
  border-radius: 50%;
  box-shadow: 0 0 8px rgba(222, 52, 49, 0.7), 0 0 16px rgba(222, 52, 49, 0.4);
  pointer-events: none;
  will-change: transform, opacity;
}

/* Optimized mobile particles */
.mobile-particles {
  pointer-events: none;
}

/* Removed CSS animations - now using framer-motion for better performance */

@media (max-width: 850px) {
  #cta-root .cta-section,
  .arsenal-cta-container .cta-section {
    flex-direction: column;
    height: auto !important;
    min-height: auto !important;
    padding: 2rem 1.5rem;
    align-items: flex-start;
  }

  .cta-content {
    max-width: 100%;
  }
  
  .cta-title br {
    display: none;
  }
  
  /* Mobile particle adjustments */
  .particle-container {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  
  .mobile-particles .particle-large {
    width: 8px;
    height: 8px;
  }
  
  .mobile-particles .particle-medium {
    width: 6px;
    height: 6px;
  }

  .desktop-only {
    display: none;
  }

  .cta-heading-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    width: 100%;
    margin-bottom: 0.75rem;
  }

  .cta-heading-text {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
  }

  .cta-mobile-pc {
    display: block;
    width: 120px;
    height: auto;
    flex-shrink: 0;
    object-fit: contain;
    filter: drop-shadow(0 0 18px rgba(222, 52, 49, 0.28));
  }

  .cta-heading-text .cta-badge {
    margin-bottom: 0.4rem;
  }

  .cta-heading-text .cta-title {
    font-size: 1.9rem;
  }

  .cta-buttons {
    width: 100%;
  }

  .btn {
    flex: 1;
    text-align: center;
  }
}

@media (max-width: 420px) {
  .cta-mobile-pc {
    width: 96px;
  }

  .cta-heading-text .cta-title {
    font-size: 1.65rem;
  }
}